export default __webpack_public_path__ + "static/media/nextCircle.76daf6ad.svg";